var map = {
	"./FacialApp.webp": 51,
	"./TheBills.webp": 52,
	"./chatapp.webp": 53,
	"./codepenclone.webp": 54,
	"./covidapp.webp": 55,
	"./quizapp.webp": 56,
	"./whatsapp.webp": 57
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50;